import { render, staticRenderFns } from "./TitleModal.vue?vue&type=template&id=22ee1dba&scoped=true&"
import script from "./TitleModal.vue?vue&type=script&lang=js&"
export * from "./TitleModal.vue?vue&type=script&lang=js&"
import style0 from "./TitleModal.vue?vue&type=style&index=0&id=22ee1dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee1dba",
  null
  
)

export default component.exports